import React, { useContext, useState } from "react";
import { UserContext } from "../UserContext";
import { motion } from "framer-motion";
import {
  SunIcon,
  MagnifyingGlassIcon,
  PowerIcon,
  ArrowLeftIcon,
} from "@heroicons/react/24/outline";
import { AiFillMoon } from "react-icons/ai";
import { HiMenu } from "react-icons/hi";
import { FaXmark } from "react-icons/fa6";
import { Link, useNavigate } from "react-router-dom";
import { HiMiniPower } from "react-icons/hi2";
import { FaUser } from "react-icons/fa6";
import { CustomConfirmDialog } from "../reusable/CustomConfirmDialog";
import { confirmAlert } from "react-confirm-alert";
import OutsideClickHandler from "react-outside-click-handler";
import useOutsideClick from "../reusable/UseOutsideClick";
// import Logo from "../../img/logo-white.webp";
import Logo from "../../img/Logo-2-100.jpg";
import ContinuumLogo from "../../img/continuum-logo.png";
import { AiOutlineLogin } from "react-icons/ai";
import MSLogoutModal from "./slices/MSLogoutModal";
import { VersionSelect } from "../reusable/VersionSelect";
import { LuPanelRightClose } from "react-icons/lu"; // Date: 7 Feb 2025
import { hasBothProductAccess } from "../reusable/ProductAccess";

export default function Header() {
  const {
    darkTheme,
    setDarkTheme,
    setIsSmMenuOpen,
    isSmMenuOpen,
    isSearchOpen,
    setIsSearchOpen,
    setResToken,
    setCodeNavigatorToken,
    isProfileOpen,
    setIsProfileOpen,
    userLoginInfo,
    isOpenLink,
    graphData,
    setGraphData,
    setSelectedHighlight,
    setIsOpenLink,
    cnUserInfo,
    versionName,
    setVersionName,
    // 7 Feb 2025
    removeGrid,
    setRemoveGrid,
    leftBarHide,
    setleftBarHide,
    iconContentTitle,
    setIconContentTitle,
    collapseLeftBarFun,
    tokenMode,
    product,
    setProduct,
    odProduct,
  } = useContext(UserContext);
  // Open Document links follow the shared article's product, not whatever
  // product (if any) this browser last picked.
  const logoProduct = isOpenLink ? odProduct : product;
  const navigate = useNavigate();

  const [isMsModalOpen, setIsMsModalOpen] = useState(false);

  // Up to 2 letters: first letter of the first two words, or the first two
  // letters of a single-word name.
  const getInitials = (name) => {
    const words = name.trim().split(/\s+/);
    return words.length > 1
      ? (words[0][0] + words[1][0]).toUpperCase()
      : name.trim().slice(0, 2).toUpperCase();
  };

  const ToggleThemeFunc = () => {
    setDarkTheme(!darkTheme);
  };
  const headerMenuToggle = () => {
    setIsSmMenuOpen(!isSmMenuOpen);
  };

  // LOGOUT FUNC
  const logoutFunc = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("cn_access_token");
    localStorage.removeItem("cn_rt");
    localStorage.removeItem("uInfo");
    localStorage.removeItem("msInfo");
    localStorage.removeItem("previousUrl");
    localStorage.removeItem("currentUrl");
    localStorage.removeItem("versionNameId");

    // Date: 12 Dec, 2024
    // Ref: Email/Meeting on 11 Dec, 2024 from Manigandan to add cn Username and version.
    // Changes: Remove Storing cn Username and version.
    localStorage.removeItem("cn_userInfo");
    setSelectedHighlight("");
    setIsOpenLink("");
    setResToken("");
    setCodeNavigatorToken("");
    setGraphData(null);
    // Date: 11 Aug 2026
    // Ref: A different user (single- or multi-access) can log into the same
    // browser next -- without clearing this, they'd inherit whichever KB the
    // previous user had picked/been auto-routed to instead of getting their
    // own chooser/auto-route decision.
    setProduct("");
    navigate("/");
  };
  // Date: 7 Aug 2026
  // Ref: Continuum KB rollout. Clears the chosen KB so MainWrapper shows the
  // chooser again, and sends the user straight to "/" so it doesn't render
  // underneath whatever nested/slug path they happened to be on.
  const switchKnowledgeBaseFunc = () => {
    setIsProfileOpen(false);
    setProduct("");
    navigate("/");
  };

  const showDialog = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <CustomConfirmDialog
            title="Are you sure?"
            message="You want to logout"
            onConfirm={() => {
              // Handle confirm action
              logoutFunc();

              onClose();
            }}
            onCancel={onClose}
          />
        );
      },
    });
  };

  // PROFILE TOGGLE
  const profileToggleHandler = () => {
    setIsProfileOpen((prev) => !prev);
  };
  const profileClick = useOutsideClick(() => setIsProfileOpen(!isProfileOpen));
  return (
    // <div className={`bg-Black max-w-[1680px] mx-auto`}>
    <div className={`max-w-[1740px] mx-auto`}>
      <div
        className={`h-[56px] px-4 sticky top-0 z-40 backdrop-blur-md flex items-center justify-between bg-cfBlue`}
      >
        {/* ${darkTheme ? "bg-Black" : "bg-Border"} */}
        <div className={`flex items-center gap-3`}>
          <div
            onClick={() => headerMenuToggle()}
            className={`block md:hidden cursor-pointer`}
          >
            {isSmMenuOpen ? (
              <FaXmark className={`w-5 h-5 text-White`} />
            ) : (
              // ${darkTheme ? "text-White" : "text-Black"}
              <HiMenu className={`w-5 h-5 text-White`} />
            )}
          </div>

          {/* Date: 7 Feb 2025  */}
          <div
            className={`hidden md:block cursor-pointer`}
            onClick={() => collapseLeftBarFun()}
          >
            {leftBarHide !== "block" ? (
              <LuPanelRightClose className={`w-5 h-5 text-White`} />
            ) : (
              <HiMenu className={`w-5 h-5 text-White`} />
            )}
          </div>
          {/* {darkTheme ? ( */}
          <img
            src={logoProduct === "continuum" ? ContinuumLogo : Logo}
            className={`h-8 md:h-10 w-auto rounded-md ${
              // Code Navigator's source image has far more empty space above
              // the glyph than below, so it reads as bottom-heavy even when
              // the image box itself is vertically centered. Continuum's
              // source image is already balanced and needs no nudge.
              logoProduct === "continuum" ? "" : "-translate-y-[17%]"
            }`}
            alt={logoProduct === "continuum" ? "Continuum logo" : "CodeNavigator logo"}
          />
          {/* ) : (
          <img src="./assets/logo-blue-black.webp" className={`w-32 md:w-44`} alt="logo" />
        )} */}
        </div>

        <div className="flex items-center gap-2">
          {/* BACK TO DASHBOARD =========
              Date: 9 Aug 2026 -- Continuum/Code Navigator are picked from
              the knowledge-base chooser (see KbChooser.js), so give
              personal-token users a one-click way back to it.
              Date: 11 Aug 2026 -- Only shown when the user actually has
              access to both products -- a single-access user has no chooser
              to go back to (see getSingleAccessibleProduct), so the button
              would just be a dead end for them. */}
          {!isOpenLink &&
            tokenMode === "personal" &&
            product &&
            hasBothProductAccess(userLoginInfo) && (
            <motion.button
              whileTap={{ scale: 0.95 }}
              whileHover={{ scale: 1.03 }}
              onClick={() => switchKnowledgeBaseFunc()}
              title="Back to dashboard"
              className={`hidden md:flex items-center gap-1.5 rounded-xl border border-[rgba(255,255,255,0.15)] bg-[rgba(255,255,255,0.08)] hover:bg-[rgba(255,255,255,0.16)] px-3 py-1.5 text-sm font-medium text-White transition-colors`}
            >
              <ArrowLeftIcon className={`w-4 h-4`} />
              <span>Back to Dashboard</span>
            </motion.button>
          )}
          {/* VERSION CONTROLLER---------START  */}
          {/* {!isOpenLink && (
            <div>
              <VersionSelect
                selectedOption={versionName}
                setSelectedOption={setVersionName}
              />
            </div>
          )} */}
          {/* Date: 27 Feb 2025  */}
          {!isOpenLink && versionName && (
            <div>
              <VersionSelect
                selectedOption={versionName}
                setSelectedOption={setVersionName}
              />
            </div>
          )}
          {/* VERSION CONTROLLER---------END  */}

          {/* <a
              href="https://cloudframe.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="hidden md:block px-3 py-1 text-White"
            >
              CloudFrame
            </a> */}
          {/* SEARCH ======== */}
          {/* Date: 8 Aug 2026 -- was bg-DarkGray, which is nearly the same
              darkness as the header's blue and left the default black
              placeholder text unreadable against it. Switched to a
              translucent white pill (matches the header chrome elsewhere)
              with an explicit light placeholder color. */}
          {/* Date: 22 Oct 2026 -- hidden on Open Document links: they show a
              single shared article, there is nothing else to search. */}
          {!isOpenLink && (
          <div
            onClick={() => setIsSearchOpen(!isSearchOpen)}
            className={`relative hidden md:flex items-center w-56 lg:w-72 rounded-xl bg-[rgba(255,255,255,0.08)] border border-[rgba(255,255,255,0.15)] cursor-pointer`}
          >
            <div className={`p-2 shrink-0`}>
              <MagnifyingGlassIcon className={`w-5 h-5 text-[#babec5]`} />
            </div>
            {/* Plain input instead of the shared <Input> -- that component
                always applies its own bg-White/bg-DarkGray, which kept
                winning over an override here and left the pill solid white
                with unreadable placeholder text. Needs an explicit width
                (flex-1) or it falls back to the browser's default input
                size and its placeholder text runs under the Ctrl+K hint. */}
            <input
              type="text"
              readOnly
              placeholder={
                product === "continuum"
                  ? "Search Continuum docs"
                  : "Search CodeNavigator docs"
              }
              className={`flex-1 min-w-0 bg-[rgba(255,255,255,0)] py-1.5 pr-3 text-sm text-White placeholder:text-[#babec5] outline-none cursor-pointer`}
            />
          </div>
          )}
          <motion.button
            whileTap={{ scale: 0.9 }}
            whileHover={{ scale: 1.1 }}
            onClick={() => ToggleThemeFunc()}
            className={`!p-2 rounded-full !bg-White/10 hover:!bg-White/20`}
          >
            <motion.div
              initial={{ opacity: 0, rotate: -90 }}
              animate={{ opacity: 1, rotate: 0 }}
              exit={{ opacity: 0, rotate: 90 }}
              transition={{ duration: 0.2 }}
            >
              {darkTheme ? (
                <SunIcon className={`w-5 h-5 !text-White`} />
              ) : (
                <AiFillMoon className={`w-5 h-5 !text-White`} />
              )}
            </motion.div>
          </motion.button>

          {/* PROFILE LOGOUT btn  */}
          <OutsideClickHandler
            onOutsideClick={() => {
              setIsProfileOpen(false);
            }}
          >
            <div>
              <button
                onClick={() => {
                  setIsProfileOpen(!isProfileOpen);
                }}
                className={`rounded-full relative transition-all`}
              >
                {userLoginInfo?.user_name || cnUserInfo?.customer_name ? (
                  <div
                    className={`flex h-8 w-8 items-center justify-center rounded-full bg-White/10 text-xs font-semibold text-White`}
                  >
                    {getInitials(
                      userLoginInfo?.user_name || cnUserInfo.customer_name,
                    )}
                  </div>
                ) : (
                  <div className={`p-2`}>
                    <FaUser className={`w-5 h-5 text-hoverClr`} />
                  </div>
                )}
              </button>
              {isProfileOpen && (
                <div
                  // ref={profileClick}
                  className={`shadow-xl min-w-64 max-w-72 border rounded-2xl absolute z-40 right-0 top-[56px] overflow-hidden ${
                    darkTheme
                      ? "bg-LightBlack border-[#333]"
                      : "bg-White border-[#e5e9f0]"
                  }`}
                >
                  {!isOpenLink && (userLoginInfo || cnUserInfo?.customer_name) && (
                    <div
                      className={`flex items-center gap-3 px-4 py-3.5 border-b ${
                        darkTheme ? "border-b-[#333]" : "border-b-[#eef1f5]"
                      }`}
                    >
                      <div
                        className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-cfBlue text-White text-xs font-semibold`}
                      >
                        {getInitials(
                          userLoginInfo?.user_name ||
                            cnUserInfo?.customer_name ||
                            "?",
                        )}
                      </div>
                      {userLoginInfo ? (
                        <span
                          className={`truncate text-sm font-semibold ${
                            darkTheme ? "text-White" : "text-Text"
                          }`}
                        >
                          {userLoginInfo.user_name}
                        </span>
                      ) : (
                        // Date: 12 Dec, 2024
                        // Ref: Email/Meeting on 11 Dec, 2024 from Manigandan to add cn Username and version.
                        <div className={`flex flex-col min-w-0`}>
                          <span
                            className={`truncate text-sm font-semibold ${
                              darkTheme ? "text-White" : "text-Text"
                            }`}
                          >
                            {cnUserInfo.customer_name}
                          </span>
                          <span
                            className={`text-[12px] ${
                              darkTheme ? "text-gray_clr-400" : "text-gray_clr-500"
                            }`}
                          >
                            App Version {cnUserInfo.platform_version}
                          </span>
                        </div>
                      )}
                    </div>
                  )}
                  <ul className={`flex flex-col gap-0.5 p-1.5`}>
                    {isOpenLink ? (
                      <Link
                        to="#"
                        onClick={() =>
                          (window.location.href = "https://ask.cloudframe.com/")
                        }
                      >
                        <li
                          className={`flex cursor-pointer items-center gap-2.5 w-full px-2.5 py-2 rounded-lg text-sm transition-colors ${
                            darkTheme
                              ? "text-gray_clr-200 hover:bg-White/[0.06]"
                              : "text-Text hover:bg-[#f2f5fa]"
                          }`}
                        >
                          <AiOutlineLogin className={`w-4 h-4 shrink-0`} />
                          <span>Login</span>
                        </li>
                      </Link>
                    ) : (
                      <li
                        onClick={() =>
                          graphData?.userPrincipalName
                            ? setIsMsModalOpen(!isMsModalOpen)
                            : showDialog()
                        }
                        className={`flex cursor-pointer items-center gap-2.5 w-full px-2.5 py-2 rounded-lg text-sm transition-colors ${
                          darkTheme
                            ? "text-gray_clr-200 hover:bg-red-500/10 hover:text-red-400"
                            : "text-Text hover:bg-red-50 hover:text-red-600"
                        }`}
                      >
                        <PowerIcon className={`w-4 h-4 shrink-0`} />
                        <span>Logout</span>
                      </li>
                    )}
                  </ul>
                </div>
              )}
            </div>
          </OutsideClickHandler>
        </div>
      </div>

      {/* MS LOGOUT MODAL BTN  */}
      {isMsModalOpen && (
        <div
          className="absolute z-40 top-0 left-0 right-0 bottom-0 bg-[#c8c8da6b] backdrop-blur h-screen flex items-center justify-center"
          onClick={() => setIsMsModalOpen(!isMsModalOpen)}
        >
          <MSLogoutModal onClose={() => setIsMsModalOpen(false)} />
        </div>
      )}
    </div>
    // </div>
  );
}
